import React, { useEffect, useState } from 'react';

// import JS files
import TabZero from '../../../customer-panels/create-order/TabZero';
import TabOne from '../../../customer-panels/create-order/TabOne';
import TabTwo from '../../../customer-panels/create-order/TabTwo';
import AdminTabThree from '../../../customer-panels/create-order/AdminTabThree';
import BasketBox from '../../../customer-panels/create-order/BasketBox';
import PanelTemplate from '../../../shares/PanelTemplate';
import { useCustomerBasket } from '../../../../context/CustomerBasketContext';
import { useLocation } from 'react-router-dom';

const CustomerCreateOrder = (props) => {
  const { selectedUserContext } = useCustomerBasket();

  const location = useLocation();

  // username selected user - combo value
  const [selectedCustomer, setSelectedCustomer] = useState(
    location.state !== null ? location.state.userInfo.username : undefined
  );

  const [selectedUser, setSelectedUser] = useState(
    location.state !== null
      ? location.state.userInfo
      : selectedUserContext !== undefined
      ? selectedUserContext
      : undefined
  );

  const [activeTab, setActiveTab] = useState('0');
  useEffect(() => {
    setSelectedUser(selectedUserContext);
  }, [selectedUserContext]);

  useEffect(() => {
    if (location.state !== null) {
      setSelectedUser(location.state.userInfo);
      setSelectedCustomer(location.state.userInfo.username);
    }
  }, [location.state]);


  return (
    <>
      <PanelTemplate sidebarActiveLink="c-create-order">
        <div className="mt-12 flex items-center">
          <span
            className={activeTab == '0' ? 'active-tab' : 'not-active-tab'}
            onClick={() => setActiveTab('0')}
          >
            انتخاب مشتری
          </span>
          <span
            className={activeTab == '1' ? 'active-tab' : 'not-active-tab'}
            onClick={() => setActiveTab('1')}
          >
            نمایش تمام محصولات
          </span>
          {/* <span
            className={activeTab == '2' ? 'active-tab' : 'not-active-tab'}
            onClick={() => setActiveTab('2')}
          >
            افزودن سریع
          </span> */}
          <span
            className={activeTab == '3' ? 'active-tab' : 'not-active-tab'}
            onClick={() => setActiveTab('3')}
          >
            خرید های قبلی
          </span>
        </div>
        <div
          style={{ backgroundColor: '#fefcfb' }}
          className="border rounded-b-md rounded-tl-md px-2 py-6 mb-4"
        >
          {activeTab == '0' ? (
            <TabZero
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
            />
          ) : activeTab == '1' ? (
            <TabOne selectedUser={selectedUser} />
          ) : activeTab == '2' ? (
            <TabTwo selectedUser={selectedUser} />
          ) : (
            <AdminTabThree
              selectedCustomer={selectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
              selectedUser={selectedUser}
            />
          )}
        </div>
        <div className="panel-main-header mt-10">
          <span>ثبت سفارش محصولات</span>
        </div>
        <BasketBox
          AdminCreateOrderForUser
          selectedCustomer={selectedCustomer}
          setSelectedUser={setSelectedUser}
          setSelectedCustomer={setSelectedCustomer}
          isAdmin
        />
      </PanelTemplate>
    </>
  );
};

export default CustomerCreateOrder;
